export default "__VITE_ASSET__BFfGJP03__"